import {useDispatch} from 'react-redux';
import {setCurrentRevisionOption} from '../../../../store/builder/revisiions/revisionsSlice';

export const useSetCurrentRevision = () => {
  const dispatch = useDispatch();

  const handleSelect = selected => {
    dispatch(setCurrentRevisionOption(selected));
  };

  return [handleSelect];
};
